/**
 * Entry point for logged-out / landing page users.
 *
 * Replaces the selective javascript_include_tag calls in _scripts.html.erb.
 * jQuery is loaded via <script> tag from /public/ BEFORE this bundle.
 */

// ── CSRF token setup for jQuery AJAX (replaces jquery_ujs) ──────────
$(document).ready(function () {
  $.ajaxSetup({
    beforeSend: function (xhr, settings) {
      if (!/^(GET|HEAD|OPTIONS|TRACE)$/i.test(settings.type) && !this.crossDomain) {
        var token = $('meta[name="csrf-token"]').attr('content');
        if (token) xhr.setRequestHeader('X-CSRF-Token', token);
      }
    }
  });
});

// ── Landing page code ────────────────────────────────────────────────
import '../landingpage.js';

// ── Language ─────────────────────────────────────────────────────────
import '../language/translate.js';

// ── Dialogs ──────────────────────────────────────────────────────────
import '../components/dialogs/dialog.module.js';
import '../components/dialogs/errorhandle.dialog.js';

// ── Validation ───────────────────────────────────────────────────────
import '../helpers/validators/validate.js';

// ── Services ─────────────────────────────────────────────────────────
import '../services/session.service.js';

// ── App root (parallax, scroll, etc.) ────────────────────────────────
import '../approot.js';
